/** Vega View object */

/** Handler of view actions */
export * from './reExport';